import * as yup from 'yup'
import { validations } from '@edenia/smartgate-errors-module'

const initialValues = {
  name: '',
  client_id: '',
  client_code_id: '',
  daily_inventory_message: '',
  servers: [
    {
      path_name: '',
      server_host: '',
      server_port: '',
      server_username: '',
      server_password: ''
    }
  ],
  locations: [
    {
      location_id: '',
      location_code: '',
      port_name: ''
    }
  ],
  liner_codes: [
    {
      liner_code_id: '',
      smartgate_liner_code_id: ''
    }
  ],
  seal_codes: [
    {
      seal_code_id: '',
      smartgate_seal_code: ''
    }
  ],
  templates: [
    {
      transaction_type: '',
      template: ''
    }
  ]
}

const schema = yup.object().shape({
  name: yup.string().required(validations.requiredField.code),
  client_id: yup.string().required(validations.requiredField.code),
  client_code_id: yup.string().required(validations.requiredField.code),
  daily_inventory_message: yup.boolean(),
  servers: yup.array().of(
    yup.object().shape({
      path_name: yup.string().required(validations.requiredField.code),
      server_host: yup.string(),
      server_port: yup.string(),
      server_username: yup.string(),
      server_password: yup.string()
    })
  ),
  locations: yup
    .array()
    .of(
      yup.object().shape({
        location_id: yup.string().required(validations.requiredField.code),
        location_code: yup.string().required(validations.requiredField.code),
        port_name: yup.string().required(validations.requiredField.code)
      })
    )
    .required(validations.requiredField.code),
  liner_codes: yup
    .array()
    .of(
      yup.object().shape({
        liner_code_id: yup.string().required(validations.requiredField.code),
        smartgate_liner_code_id: yup
          .string()
          .required(validations.requiredField.code)
      })
    )
    .required(validations.requiredField.code),
  seal_codes: yup
    .array()
    .of(
      yup.object().shape({
        seal_code_id: yup.string().required(validations.requiredField.code),
        smartgate_seal_code: yup
          .string()
          .required(validations.requiredField.code)
      })
    )
    .required(validations.requiredField.code),
  templates: yup
    .array()
    .of(
      yup.object().shape({
        transaction_type: yup.string().required(validations.requiredField.code),
        template: yup.string().required(validations.requiredField.code)
      })
    )
    .required(validations.requiredField.code)
})

export default {
  initialValues,
  schema
}
